import type { Genome, EvolutionTrait } from '@/domain/genetics/types';

export type DeathCause = 'neglect' | 'old-age' | 'expedition' | 'alive';

export interface LineageNode {
  creatureId: string;
  name: string;
  bornAt: number;
  diedAt: number | null;
  cause: DeathCause;
  parentIds: [string | null, string | null];
  childrenIds: string[];
  genomeSnapshot: Genome;
  traitsSnapshot: EvolutionTrait[];
}

export interface LineageGraph {
  nodes: Record<string, LineageNode>;
  rootId: string | null;
}

export class LineageCycleError extends Error {
  constructor(childId: string, parentId: string) {
    super(`Lineage cycle: child ${childId} já é ancestral de pretendido pai ${parentId}`);
  }
}
